import { StudentProfileFormConfigs } from './FormConfigs';
import { CareerProfileFormContext, type FormConfig } from './FormConfigs.types';

/**
 * The single place that maps a form context to its list of steps.
 *
 * This takes `applicationFormConfigs` as an argument instead of a user because the callers read it
 * from different places. Some read `user.relevantCohort.applicationFormConfigs`, while
 * navigationSectionConfigs reads `programTypeConfig.applicationFormConfigs`. Both resolve to the same
 * array today, since Schedulable delegates the property to the program type, but that is not this
 * function's decision to make.
 *
 * Both branches return the caller's array by reference rather than a copy, so repeated calls with the
 * same context return the same array. edit_career_profile_dir.js watches `steps`, and settings_dir.js
 * calls this on every save.
 */
export const getFormConfigsForContext = (
    context: CareerProfileFormContext,
    applicationFormConfigs?: FormConfig[],
): FormConfig[] =>
    context === CareerProfileFormContext.application ? (applicationFormConfigs ?? []) : StudentProfileFormConfigs;
